// (function () {
//   //Remove the view transition render blocker if the user has reduced motion enabled
//   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//     const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
//     if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
//   }

//   const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

//   /**
//    * @param {PageSwapEvent} event
//    */
//   window.addEventListener('pageswap', async (event) => {
//     if (!hasViewTransition(event)) return;

//     const { viewTransition } = event;

//     // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
//     document
//       .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
//       .forEach((element) => {
//         element.removeAttribute('data-view-transition-type');
//       });

//     const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
//     const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

//     if (transitionType) {
//       viewTransition.types.clear();
//       viewTransition.types.add(transitionType);
//       sessionStorage.setItem('custom-transition-type', transitionType);
//     } else {
//       viewTransition.types.clear();
//       viewTransition.types.add('page-navigation');
//       sessionStorage.removeItem('custom-transition-type');
//     }
//   });

//   /**
//    * @param {PageRevealEvent} event
//    */
//   window.addEventListener('pagereveal', async (event) => {
//     if (!hasViewTransition(event)) return;

//     const { viewTransition } = event;
//     const customTransitionType = sessionStorage.getItem('custom-transition-type');

//     if (customTransitionType) {
//       viewTransition.types.clear();
//       viewTransition.types.add(customTransitionType);

//       await viewTransition.finished;

//       viewTransition.types.clear();
//       viewTransition.types.add('page-navigation');

//       idleCallback(() => {
//         sessionStorage.removeItem('custom-transition-type');
//         document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
//           element.removeAttribute('data-view-transition-type');
//         });
//       });
//     } else {
//       viewTransition.types.clear();
//       viewTransition.types.add('page-navigation');
//     }
//   });

//   /**
//    * Checks whether an Event object is carrying a `viewTransition` property
//    * (as used by the View Transition API) and narrows the type accordingly.
//    *
//    * @template {Event} T
//    * @param {T} event
//    * @returns {event is T & { viewTransition: ViewTransition }}
//    */
//   function hasViewTransition(event) {
//     return 'viewTransition' in event && event.viewTransition instanceof ViewTransition;
//   }
// })();
(function () {
  // Exit early if View Transitions API is not supported
  if (!('ViewTransition' in window)) return;

  // Respect reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const blocker = document.getElementById('view-transition-render-blocker');
    if (blocker) blocker.remove();
    return;
  }

  const idleCallback =
    typeof requestIdleCallback === 'function'
      ? requestIdleCallback
      : (cb) => setTimeout(cb, 1);

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;

    // Clean up any leftover transition types
    document
      .querySelectorAll(
        '[data-view-transition-type]:not([data-view-transition-triggered])'
      )
      .forEach((el) => {
        el.removeAttribute('data-view-transition-type');
      });

    const triggered = document.querySelector(
      '[data-view-transition-triggered]'
    );
    const transitionType =
      triggered?.getAttribute('data-view-transition-type');

    viewTransition.types.clear();

    if (transitionType) {
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    const storedType = sessionStorage.getItem('custom-transition-type');

    viewTransition.types.clear();

    if (storedType) {
      viewTransition.types.add(storedType);
      await viewTransition.finished;
    }

    viewTransition.types.clear();
    viewTransition.types.add('page-navigation');

    idleCallback(() => {
      sessionStorage.removeItem('custom-transition-type');
      document
        .querySelectorAll('[data-view-transition-type]')
        .forEach((el) => el.removeAttribute('data-view-transition-type'));
    });
  });

  /**
   * @param {Event} event
   */
  function hasViewTransition(event) {
    return (
      'viewTransition' in event &&
      event.viewTransition instanceof ViewTransition
    );
  }
})();
